import { Component } from '@angular/core';

@Component({
  selector: 'audako4-page-not-found',
  template: `
    <div style="text-align: center; padding-top: 20%">
      <h2>Page not found</h2>
      <h3>404</h3>
    </div>
  `,
  styles: []
})
export class PageNotFoundComponent {
  constructor() {}
}
